import angular from 'angular';

import Component from './experience-calendar.component';

const ExperienceCalendar = angular
    .module('control-room.experience-promoter.components.experience-calendar', [])
    .component('crExperienceCalendar', Component);

export default ExperienceCalendar;
